import { aludraApi } from 'api/axios'
import { coreUrls } from './core.urls'

export const customerById = id => {
  return aludraApi.get(coreUrls.customerURL + id)
}

export const registerCustomer = async payload => {
  return aludraApi.post(coreUrls.registerURL, payload)
}

export const updateCustomer = async payload => {
  return aludraApi.post(coreUrls.updateURL, payload)
}

export const priceReasons = async payload => {
  return aludraApi.post(coreUrls.razonesPrecioURL, payload)
}

export const restorePassword = async payload => {
  return aludraApi.post(coreUrls.restoreURL, payload)
}

export const loginUser = async payload => {
  return aludraApi.post(coreUrls.loginURL, payload)
}

export const loginCompany = async payload => {
  return aludraApi.get(coreUrls.loginCompanyURL + payload)
}

export const searchCustomerDisplaySettings = async payload => {
  return aludraApi.post(coreUrls.customerDisplaySettingsSearch, payload)
}
